import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
        image: '/assets/images/works/go4network/9.png',
        category: 'Mobile App (Flutter/Kotlin)',
        title: 'Go4Network – Monetize Unused SMS Quotas',
        url: 'go4network'
    },
    {
        image: '/assets/images/works/go4contact/5.png',
        category: 'Web App (Node.js/Laravel/Vue.js)',
        title: 'Go4Contact – Rich Messaging Web App',
        url: 'go4contact'
    },
    {
        image: '/assets/images/works/go4rit/1.png',
        category: 'eCommerce (Vue.js/Laravel)',
        title: 'GO4Rit – eCommerce for Reducing Food Waste',
        url: 'go4rit'
    },
    {
        image: '/assets/images/works/represence/1.png',
        category: 'Mobile App + Back End (Flutter/GoLang/MongoDB)',
        title: 'rePresence App',
        url: 'represence'
    },
    {
        image: '/assets/images/works/atourin/1.jpg',
        category: 'Mobile App (Flutter)',
        title: 'Atourin Mobile',
        url: 'atourin'
    },
    {
        image: '/assets/images/works/halo-browser/1.png',
        category: 'Mobile App (Android Native)',
        title: 'Halo Browser - Proxy Integrated Browser',
      
    },
    {
        image: '/assets/images/works/lifeducare/1.jpg',
        category: 'Experimental Project (Nuxt/Firebase)',
        title: 'Lifeducare',
      
    },

    {
        image: '/assets/images/works/zodiak-corner/1.png',
        category: 'Mobile App (Android Native',
        title: 'Zodiak Corner',
     
    },
    {
        image: '/assets/images/works/quick-count-pilpres/1.jpg',
        category: 'Front-End Website (Vue.Js)',
        title: 'Quick Count Pilpres - Website',


    }
]

interface Props {
    column?: string;
    styevariation?: string;
    item?: any;
}

class PortfolioList extends Component<Props>{
    render(): React.ReactNode{
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index} >
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`} style={{ backgroundImage: `url("${value.image}")`}}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4>{value.title}</h4>
                                    {value.url != null ? (
                                        <div className="portfolio-button">
                                            <Link to={`/projects/${value.url}`} className="rn-btn">View Details</Link>
                                        </div>
                                    ) : null
                                    }
                                    
                                 
                                    
                                </div>
                            </div>
                            {/* <Link className="link-overlay" to="/portfolio-details"></Link> */}
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;